<div class="flex justify-between items-start bg-gray-50 p-4 gap-4 rounded-l my-6">
  <form class="flex flex-wrap gap-4" [formGroup]="formGroup">
    <flow-form-input label="media.filters.text" formControlName="text"></flow-form-input>
    <div class="flex flex-col">
      <flow-form-select
        formControlName="isActive"
        [label]="'channels.table.status'"
        [multiple]="true"
        [options]="channelStatusOptions"></flow-form-select>
    </div>
  </form>
  <div class="flex gap-4 mt-8">
    <flow-button theme="light" variation="fill" [isCapitalize]="false" (onClick)="clearAll()">
      {{ 'global.clearAll' | translate }}
    </flow-button>
    <flow-button theme="primary" variation="fill" (onClick)="submit()">
      <span>{{ 'global.show' | translate }}</span>
    </flow-button>
  </div>
</div>
